/**
 * Sportsnew "main odds" (home/draw/away) result-market labeling policy.
 *
 * The API's mainOdds SHAPE is the single source of truth for whether a
 * fixture's main result market is 2-way (home/away) or 3-way (home/draw/
 * away) — never sport lookup or layout. Per sport policy the backend only
 * ever includes a `draw` slot for soccer/ice-hockey (3-way, "승무패");
 * basketball/volleyball/baseball/eSports omit it entirely (2-way, "승패").
 * Keying the frontend's label/rendering off the ACTUAL shape — rather than
 * hardcoding a per-sport assumption — means the display never shows a draw
 * slot the API didn't send, and stays correct even without a frontend
 * change if backend policy is ever adjusted.
 */
export const hasMainOddsDraw = (mainOdds) => !!mainOdds?.draw?.oddStateId;

export const mainOddsResultLabel = (mainOdds) => (hasMainOddsDraw(mainOdds) ? '승무패' : '승패');
